import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useSupabaseSession } from "@/hooks/useSupabaseSession";
import { supabase } from "@/integrations/supabase/client";

export default function Dashboard() {
  const { user, loading } = useSupabaseSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) navigate("/auth", { replace: true });
  }, [loading, user, navigate]);

  if (loading) return <div className="p-6">Loading…</div>;
  if (!user) return null;

  return (
    <main className="mx-auto max-w-4xl px-6 py-10">
      <h1 className="text-2xl font-semibold">Admin Dashboard</h1>
      <p className="text-muted-foreground mt-2">Welcome, {user.email}</p>
      <div className="mt-6">
        <Button variant="outline" onClick={() => supabase.auth.signOut().then(() => navigate("/"))}>
          Sign out
        </Button>
      </div>
    </main>
  );
}
